import script from "./CMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CMessage.vue?vue&type=script&lang=ts&setup=true"

import "./CMessage.vue?vue&type=style&index=0&id=54724ba6&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\ldcloud\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54724ba6"]])

export default __exports__